
    import Vue from "vue";
    import Component from "vue-class-component";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import DatePicker from "@/vue/components/DatePicker.vue";
    import VisitViewHeader from "@/vue/components/VisitViewHeader.vue";
    import VisitViewDetail from "@/vue/components/VisitViewDetail.vue";
    import { IVisitSearchResult, VisitSearchResult } from "@/model/VisitSearchResult";
    import { ILookupItem } from "@/model/LookupItem";
    import { IVisit } from "@/model/Visit";

    interface IQrCodeVisitListResponse {
        visitList: Array<IVisitSearchResult>;
        visitorCompanyList: Array<ILookupItem>;
        recipientList: Array<ILookupItem>;
    }

    @Component({
        components: { ApiButton, PrimaryButton, DatePicker, VisitViewHeader, VisitViewDetail }
    })
    export default class Visits extends Vue {

        async mounted(): Promise<void> {
            this.qrKey = this.$router.currentRoute.params.key;
            this.load();
        }

        //
        // -- properties
        //

        qrKey: string = "";
        shouldShowDialogue: boolean = false;
        resultCount: string = "-";
        visitorCompanyList: Array<ILookupItem> = [];
        recipientList: Array<ILookupItem> = [];
        visitList: Array<VisitSearchResult> = [];
        searchResult = new VisitSearchResult();

        //
        // -- methods
        //

        visitImageSource(result: VisitSearchResult): string {
            return Utils.isEmptyId(result?.visit?.photoResource?.id)
                ? result?.siteImage?.sourceUrl ?? require("@/images/missing.png")
                : result?.visit?.photoResource?.sourceUrl ?? require("@/images/missing.png");
        }

        async viewDetail(result: IVisitSearchResult): Promise<void> {
            this.searchResult.update(result);
            // need to load a bit more info...
            const visitData: IVisit = await ApiClient.get(`api/visit/Load?id=${result.visit.id}&qrKey=${this.qrKey}`);
            this.searchResult.visit.update(visitData);
            this.shouldShowDialogue = true;
        }

        async load(): Promise<void> {
            const response: IQrCodeVisitListResponse = await ApiClient.get(`/Api/Visit/QrCodeVisitList?qrKey=${this.qrKey}`);
            //console.log("Data = ", response);
            this.visitorCompanyList = response.visitorCompanyList;
            this.recipientList = response.recipientList;
            this.resultCount = String(response.visitList.length);
            this.visitList.push(...response.visitList.map((v: IVisitSearchResult) => new VisitSearchResult(v)));
        }
    }
